'use strict';

var _typeof$1 = require('./typeof.js');
var assertThisInitialized$1 = require('./assertThisInitialized.js');

var _typeof = _typeof$1._typeof_1;

var assertThisInitialized = assertThisInitialized$1;

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

var possibleConstructorReturn = _possibleConstructorReturn;

module.exports = possibleConstructorReturn;
